import type { ReactNode } from 'react'

import { IconQuestionMarkCircle } from '@gto/ui/assets'
import { cn } from '@gto/ui/cn'
import { ExclamationCircleIcon } from '@gto/ui/icons/outline'
import { Typography } from '@gto/ui/typography'

export type DescriptionItemProps = {
  text: string | ReactNode
  color: 'warning.main' | 'action.active'
}

export const DescriptionItem = ({ text, color }: DescriptionItemProps) => {
  return (
    <div className="flex items-center gap-[10px]">
      <div
        className={cn(color === 'warning.main' ? 'text-warning-main' : 'text-text-action-active')}
      >
        {color === 'warning.main' ? (
          <ExclamationCircleIcon width={24} />
        ) : (
          <IconQuestionMarkCircle
            height={24}
            width={24}
          />
        )}
      </div>
      <Typography variant="body3">{text}</Typography>
    </div>
  )
}
